import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tower-identify-container" }
const _hoisted_2 = { class: "inner-content" }
const _hoisted_3 = { class: "content" }

import { ref, onMounted,getCurrentInstance,onBeforeMount, computed } from 'vue';
import { getSceneInfoTabList, getAirLineDetail, getUotsDeviceDetail } from '@/service'
import {useStore} from 'vuex'
import {useRouter, useRoute} from 'vue-router'
import {$enum, $config} from '@/global/index'
import ReviewHeader from '@/components/modules/reviewHeader/index.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const router = useRouter()
const cardsList = ref<any[]>([])
const { proxy } = getCurrentInstance()!
const selectedCardId = computed(() => store.state.persistence.carouselSelection?.towerCardId ?? null)
const title = computed(() => store.state.persistence.towerIdentify?.title ?? null)


async function getPageData(){
    cardsList.value = []
    let param = {
        "userId": store.state.persistence.userInfo.userId,
        "tenantId": store.state.persistence.currentTenantId,
        "sceneCategoryId":store.state.persistence.towerIdentify.sceneCategoryId,
        "sceneTypeId": store.state.persistence.towerIdentify.sceneTypeId
    }
    const {code, data, message} = await getSceneInfoTabList(param);
    if(code == $enum.EnumResult.SUCCESS){
        if(Array.isArray(data) && data.length){
            let arr = []
            data.forEach((item, index) => {
                arr.push({
                    ...item,
                    id: item.id,
                    title: item?.sceneSubTypeName,
                    description: item.typeDescription,
                    userAvailable: item.isLocked,
                    pictureUrl: $config.FILE_ROOT_PATH + item.pictureUrl,
                    sortIndex: index + 1 < 10? '0' + (index + 1) : index + 1,
                    isLocked: item.isLocked
                })
            });
            cardsList.value = arr
        }
    }
}

function handleBack(){
  window?.playClick()
  router.push('/home')
}

async function handleClick(cardItem: any){
  if(cardItem.isLocked) return
  store.commit('persistence/setCarouselSelection', {
    ...store.state.persistence.carouselSelection,
    towerCardId: cardItem.id
  })
  const deviceRes = await getUotsDeviceDetail({
    deviceId: cardItem.stationList[0]?.deviceId,
  })
  const airLineRes = await getAirLineDetail({
    airLineId: cardItem.stationList[0]?.airLineId,
    deviceId: cardItem.stationList[0]?.deviceId,
  })
  const airlineDetail = airLineRes.code == $enum.EnumResult.SUCCESS ? airLineRes.data : null
  const deviceDetail = deviceRes.code == $enum.EnumResult.SUCCESS ? deviceRes.data : null
  store.commit('persistence/setTowerIdentify', {
    ...store.state.persistence.towerIdentify,
    sceneInfo: cardItem,
    airlineDetail,
    deviceDetail
  })
  store.commit("persistence/setStationId", cardItem.stationList[0]?.stationId);
  router.push('/flight/towerView')
}

/** 清除场景标识信息并重新获取页面数据 */

onBeforeMount(() => {
  store.commit('persistence/setTowerIdentify', {
    ...store.state.persistence.towerIdentify,
    airlineDetail:null,
    deviceDetail:null,
  })
  getPageData()
})


return (_ctx: any,_cache: any) => {
  const _component_vkm_carousel = _resolveComponent("vkm-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ReviewHeader, {
        class: "tower-identify-header",
        title: title.value,
        onBack: handleBack
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_vkm_carousel, {
          cardsList: cardsList.value,
          useControls: true,
          onOnClick: handleClick,
          isShowMode: _ctx.isShowMode,
          isShowSort: true,
          isShowLock: true,
          supportSelect: true,
          selectedCardId: selectedCardId.value
        }, null, 8, ["cardsList", "isShowMode", "selectedCardId"])
      ])
    ])
  ]))
}
}

})